import { InputField } from '@atoms/input';
import { TraceKeyInput } from '@components/traceKeyInput/traceKeyInput';
import { Separator } from '@components/ui/separator';
import useAction from '@hooks/useAction';
import { observer } from 'mobx-react';
import type { ChangeEvent } from 'react';

type Props = {
  children?: React.ReactNode;
};
export const SettingsSharedTab = observer(({ children }: Props) => {
  const action = useAction();

  if (!action) {
    return <div>No action found</div>;
  }

  const onActionNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    action._metadata.name = event.target.value;
  };

  return (
    <section className="h-full bg-[#fafafa] p-6">
      <section className="flex h-full w-full flex-col gap-6">
        {children && (
          <>
            {children}
            <Separator />
          </>
        )}
        <InputField
          label="Action name"
          onChange={onActionNameChange}
          placeholder="Aa"
          required
          value={action._metadata.name}
        />
        <TraceKeyInput parentName={action.name} traceKey={action.traceKey} />
      </section>
    </section>
  );
});
